module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/contacts/bournemouth/"},"frontmatter":{"title":"Bournemouth","address":"Parley Green Lane<br/>\nChristchurch<br/>\nBH23 6BB","tel":"+44 (0)1202 597 140","email":"henry.debenham@rla.co.uk"}}},{"node":{"fields":{"slug":"/contacts/london/"},"frontmatter":{"title":"London","address":"36 Percy Street<br/>\nLondon<br/>\nW1T 2DH","tel":"+44 (0)1202 597 140","email":"henry.debenham@rla.co.uk"}}}]}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 711
// module chunks = 60335399758886 114276838955818